import React from 'react';
import { connect } from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage, injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import GriffinNumber from 'griffin-paypal/lib/client/number';
import _ from 'lodash';
import OfferTile from '../../../shared-components/OfferTileGroup/OfferTile';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import '../../../shared-components/CycoPageForm/CycoPage.less';
import { Field } from 'redux-form';

const LOCALE_PREFIX = 'components/CycoPageForm/cycoPageForm';

export const CycoPageCoreContent = ({ currencySymbol, coreOffer, griffinNumberHandler, isReuse, mppInstallmentsTermsUrl }) => {
    const isAcq = !isReuse;
    const postFix = isAcq ? 'acq' : 'reuse';
    const currency = _.get(coreOffer, 'total_cost.currency_code');

    const formatCurrency = (value = 0) => griffinNumberHandler.formatCurrency({
        currency,
        value
    });

    const paymentDetails = {
        apr: `${_.toNumber(_.get(coreOffer, 'credit_financing.apr'))}%`,
        dueToday: `${currencySymbol}0.00`,
        financingCode: _.get(coreOffer, 'credit_financing.financing_code'),
        paymentRate: formatCurrency(_.get(coreOffer, 'monthly_payment.value')),
        paymentDuration: _.get(coreOffer, 'credit_financing.term'),
        totalInterestAmount: formatCurrency(_.get(coreOffer, 'total_interest.value')),
        totalCostAmount: formatCurrency(_.get(coreOffer, 'total_cost.value'))
    };

    return (
        <React.Fragment>
            <div className="cycoPage-core-header">
                <div className="vx_text-1 cycoTitle cyco-textCenter">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cycopagecore-title-${postFix}`} />
                </div>
                <div className="vx_text-5 cycoTitleDesc cyco-textCenter">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cycopagecore-subtitle-${postFix}`} />
                </div>
            </div>

            {isAcq && (
                <p className="cycoPage-core-valueProp vx_text-4 cyco-textCenter">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cycopagecore-valueprop-${postFix}`} />
                </p>
            )}

            <div className="cycoPage-pieChart" />

            <Field
                id={`control_${paymentDetails.financingCode}`}
                name="offer"
                component={OfferTile}
                className="offerTile--core"
                isSelectable={false}
                isInstallment={true}
                localePrefix={LOCALE_PREFIX}
                {...paymentDetails}
            />

            <p className="cycoPage-stca cycoPage-stca--core">
                {isAcq && (
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cycopagecore-stca-${postFix}`}>
                        {txt => <span>{txt} </span>}
                    </FormattedHTMLMessage>
                )}
                <PopupLink className="cycoSeeTermsLink" url={mppInstallmentsTermsUrl}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-see-terms-link`} />
                </PopupLink>
            </p>

        </React.Fragment>
    );
};

CycoPageCoreContent.propTypes = {
    currencySymbol: PropTypes.string.isRequired,
    coreOffer: PropTypes.object.isRequired,
    griffinNumberHandler: PropTypes.object.isRequired,
    isReuse: PropTypes.bool.isRequired,
    mppInstallmentsTermsUrl: PropTypes.string.isRequired
};

CycoPageCoreContent.defaultProps = {
    coreOffer: {},
    isReuse: false
};

export const mapStateToProps = state => ({
    currencySymbol: _.get(state, 'serverData.currencySymbol'),
    griffinNumberHandler: GriffinNumber.createHandler(state.serverData.localityMetadata),
    isReuse: _.get(state, 'serverData.isReuse', false),
    mppInstallmentsTermsUrl: _.get(state, 'serverData.mppInstallmentsTermsUrl', ''),
});

export default connect(mapStateToProps)(injectIntl(CycoPageCoreContent));
